import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { Icon } from "./icons";
import "./Dashboard.css";

const API_BASE =
  process.env.REACT_APP_API_URL || "https://backend-9i6n.onrender.com";

const STAT_META = {
  "एकूण सूचना": { icon: Icon.bell, color: "#1B6CA8", bg: "#EAF3FA" },
  "विकास कामे ": { icon: Icon.tool, color: "#1B6CA8", bg: "#EAF3FA" },
  "शासकीय योजना": { icon: Icon.building, color: "#2E7D32", bg: "#EFF6EF" },
  "सदस्य": { icon: Icon.people, color: "#2E7D32", bg: "#EFF6EF" },
  "सेवा अर्ज": { icon: Icon.doc, color: "#1B6CA8", bg: "#EAF3FA" },
};

const QUICK_ACTIONS = [
  { to: "/admin/notices", label: "नवीन सूचना", icon: Icon.bell, color: "#1B6CA8" },
  { to: "/admin/schemes", label: "नवीन योजना", icon: Icon.building, color: "#2E7D32" },
  { to: "/admin/gallery", label: "छायाचित्र अपलोड", icon: Icon.image, color: "#1B6CA8" },
  { to: "/admin/services", label: "सेवा अर्ज पहा", icon: Icon.doc, color: "#2E7D32" },
];

const getGreeting = () => {
  const h = new Date().getHours();
  if (h < 12) return "सुप्रभात";
  if (h < 18) return "नमस्कार";
  return "शुभ संध्या";
};

const todayLabel = () => {
  try {
    return new Date().toLocaleDateString("mr-IN", {
      weekday: "long",
      day: "numeric",
      month: "long",
      year: "numeric",
    });
  } catch {
    return new Date().toLocaleDateString();
  }
};

const Dashboard = () => {
  const [stats, setStats] = useState([]);
  const [recentActivities, setRecentActivities] = useState([]);
  const [pendingCount, setPendingCount] = useState(0);
  const [loading, setLoading] = useState(true);

  const token = localStorage.getItem("token"); // ✅ ADMIN TOKEN

  const fetchDashboardData = async () => {
    try {
      setLoading(true);

      // ✅ PUBLIC APIs
      const noticesRes = await axios.get(`${API_BASE}/api/notices`);
      const schemesRes = await axios.get(`${API_BASE}/api/schemes`);
      const membersRes = await axios.get(`${API_BASE}/api/contacts`);
      const devlopmentcount = await axios.get(`${API_BASE}/api/development`);

      // ✅ ADMIN API (WITH TOKEN)
      let servicesCount = 0;
      try {
        const servicesRes = await axios.get(
          `${API_BASE}/api/admin/services`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        servicesCount = servicesRes.data.filter(
          (s) => s.status?.toLowerCase() === "pending"
        ).length;
      } catch (err) {
        console.warn("Admin services access denied");
      }
      setPendingCount(servicesCount);

      // ✅ SET STATS
      setStats([
        { label: "एकूण सूचना", value: noticesRes.data.length },
        { label: "विकास कामे ", value: devlopmentcount.data.length },
        { label: "शासकीय योजना", value: schemesRes.data.length },
        { label: "सदस्य", value: membersRes.data.length },
        { label: "सेवा अर्ज", value: servicesCount },
      ]);

      // ✅ RECENT ACTIVITIES
      const activities = noticesRes.data.slice(0, 5).map((n) => ({
        action: `सूचना जोडली: ${n.title}`,
        time: new Date(n.createdAt).toLocaleString("mr-IN"),
      }));

      setRecentActivities(activities);
    } catch (error) {
      console.error("Dashboard fetch error:", error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDashboardData();
  }, []);

  /* ================= LOADING ================= */
  if (loading) {
    return (
      <div className="admin-page">
        <div className="loading-container">
          <div className="loading-spinner"></div>
          <p className="loading-text">डॅशबोर्ड लोड होत आहे...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="admin-page">
      {/* HEADER */}
      <div className="gp-page-head">
        <div>
          <h1>{getGreeting()}, प्रशासक 👋</h1>
          <p>ग्राम पंचायत प्रशासन डॅशबोर्डमध्ये आपले स्वागत आहे</p>
        </div>
        <div className="dash-date-chip">
          <Icon.calendar size={15} strokeWidth={2} />
          {todayLabel()}
        </div>
      </div>

      {/* STATS */}
      <div className="dash-stats-grid">
        {stats.map((stat, index) => {
          const meta = STAT_META[stat.label] || {
            icon: Icon.info,
            color: "#1B6CA8",
            bg: "#EAF3FA",
          };
          return (
            <div key={index} className="gp-card gp-card--hover dash-stat-card">
              <span
                className="dash-stat-icon"
                style={{ background: meta.bg, color: meta.color }}
              >
                <meta.icon size={19} />
              </span>
              <div className="dash-stat-value">{stat.value}</div>
              <div className="dash-stat-label">{stat.label.trim()}</div>
            </div>
          );
        })}
      </div>

      <div className="dash-columns">
        {/* RECENT ACTIVITIES */}
        <div className="gp-card dash-activity-card">
          <div className="dash-card-head">
            <h2>अलीकडील घडामोडी</h2>
          </div>

          {recentActivities.length === 0 ? (
            <div className="gp-empty">कोणतीही अलीकडील माहिती उपलब्ध नाही</div>
          ) : (
            <div className="dash-activity-list">
              {recentActivities.map((activity, index) => (
                <div key={index} className="dash-activity-item">
                  <span className="dash-activity-icon">
                    <Icon.bell size={16} />
                  </span>
                  <div className="dash-activity-text">
                    <p>{activity.action}</p>
                    <span>{activity.time}</span>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* SIDE COLUMN */}
        <div className="dash-side-col">
          <div className="gp-card dash-quick-card">
            <h2>जलद कृती</h2>
            <div className="dash-quick-grid">
              {QUICK_ACTIONS.map((qa) => (
                <Link
                  key={qa.to}
                  to={qa.to}
                  className="dash-quick-item"
                  style={{ "--qa-color": qa.color }}
                >
                  <qa.icon size={20} strokeWidth={1.9} />
                  <span>{qa.label}</span>
                </Link>
              ))}
            </div>
          </div>

          <div className="dash-pending-card">
            <div className="dash-pending-label">प्रलंबित सेवा अर्ज</div>
            <div className="dash-pending-value">
              <span>{pendingCount}</span>
              <small>अर्ज कार्यवाहीच्या प्रतीक्षेत</small>
            </div>
            <Link to="/admin/services" className="dash-pending-btn">
              आता तपासा
              <Icon.arrowRight size={15} strokeWidth={2.2} />
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
